/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StatusResponse = {
    New: 'NEW',
    Pending: 'PENDING',
    Refused: 'REFUSED',
    Accepted: 'ACCEPTED'
} as const;
export type StatusResponse = typeof StatusResponse[keyof typeof StatusResponse];


export function instanceOfStatusResponse(value: any): boolean {
    for (const key in StatusResponse) {
        if (Object.prototype.hasOwnProperty.call(StatusResponse, key)) {
            // @ts-ignore
            if (StatusResponse[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusResponseFromJSON(json: any): StatusResponse {
    return StatusResponseFromJSONTyped(json, false);
}

export function StatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusResponse {
    return json as StatusResponse;
}

export function StatusResponseToJSON(value?: StatusResponse | null): any {
    return value as any;
}

